import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApp } from '../../context/AppContext'
import { supabase } from '../../lib/supabase'
import { authedFetch } from '../../lib/api'
import './Profile.css'

export default function Profile() {
  const { user, profile, userState, signOut, loadUserData } = useApp()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [confirmaAnulare, setConfirmaAnulare] = useState(false)
  const [confirmaReset, setConfirmaReset] = useState(false)

  const subStatus = userState?.subscription_status
  const abonat = userState?.has_paid === true
  const anulatLaFinal = subStatus === 'cancel_at_period_end'

  async function anuleazaAbonament() {
    setLoading(true)
    try {
      const res = await authedFetch('/cancel-subscription', { method: 'POST' })
      if (!res.ok) throw new Error('cancel failed')
      await loadUserData(user.id)
    } catch (e) {
      console.error('cancel error:', e)
    }
    setLoading(false)
    setConfirmaAnulare(false)
  }

  async function resetOnboarding() {
    setLoading(true)
    await supabase.from('user_profiles').update({ ai_profil: null, onboarding_completat: false }).eq('user_id', user.id)
    await loadUserData(user.id)
    setLoading(false)
    navigate('/onboarding')
  }

  const financiar = profile?.profil_financiar
  const gravitate = profile?.gravitate

  return (
    <div className="profile-page">
      <h1>Profilul tau</h1>

      <div className="profile-section">
        <div className="profile-field"><span className="pf-label">Email</span><span className="pf-value">{user?.email}</span></div>
        <div className="profile-field">
          <span className="pf-label">Abonament simulator</span>
          <span className={`pf-value badge ${abonat ? (anulatLaFinal ? 'badge-amber' : 'badge-green') : 'badge-red'}`}>
            {abonat ? (anulatLaFinal ? 'Activ pana la finalul perioadei' : 'Abonat (34,99 lei/luna)') : 'Fara abonament'}
          </span>
        </div>
      </div>

      {profile && (
        <div className="profile-section">
          <h2>Profilul AI</h2>
          <div className="profile-field"><span className="pf-label">Nivel dependenta</span><span className={`pf-value badge badge-${gravitate?.nivel === 'scazut' ? 'green' : gravitate?.nivel === 'critic' ? 'red' : 'amber'}`}>{gravitate?.nivel}</span></div>
          <div className="profile-field"><span className="pf-label">Scor</span><span className="pf-value">{gravitate?.scor}/100</span></div>
          <div className="profile-field"><span className="pf-label">Venit lunar</span><span className="pf-value">{financiar?.venit_lunar} lei</span></div>
          <div className="profile-field"><span className="pf-label">Buget zilnic joc</span><span className="pf-value">{financiar?.buget_zilnic_joc} lei</span></div>
          <div className="profile-field"><span className="pf-label">Miza per spin</span><span className="pf-value">{profile?.slot_config?.miza_per_spin} lei</span></div>
        </div>
      )}

      <div className="profile-section profile-actions">
        <h2>Actiuni</h2>

        {!confirmaReset ? (
          <button className="btn-ghost profile-action-btn" onClick={() => setConfirmaReset(true)}>
            🔄 Refac onboarding-ul
          </button>
        ) : (
          <div className="confirma-box">
            <p>Sigur vrei sa refaci onboarding-ul? Profilul curent se va sterge.</p>
            <div className="confirma-btns">
              <button className="btn-primary" onClick={resetOnboarding} disabled={loading}>Da, refac</button>
              <button className="btn-ghost" onClick={() => setConfirmaReset(false)}>Anuleaza</button>
            </div>
          </div>
        )}

        {abonat && !anulatLaFinal && !confirmaAnulare && (
          <button className="btn-ghost profile-action-btn red" onClick={() => setConfirmaAnulare(true)}>
            ✕ Anuleaza abonamentul
          </button>
        )}

        {!abonat && (
          <button className="btn-ghost profile-action-btn" onClick={() => navigate('/payment')}>
            ⭐ Deblocheaza simulatorul
          </button>
        )}

        {confirmaAnulare && (
          <div className="confirma-box">
            <p>Sigur vrei sa te dezabonezi? Pastrezi accesul la simulator pana la finalul perioadei deja platite.</p>
            <div className="confirma-btns">
              <button className="btn-primary" style={{background:'var(--red)'}} onClick={anuleazaAbonament} disabled={loading}>Da, anulez</button>
              <button className="btn-ghost" onClick={() => setConfirmaAnulare(false)}>Nu, raman</button>
            </div>
          </div>
        )}

        <button className="btn-ghost profile-action-btn" onClick={signOut}>
          🚪 Deconecteaza-te
        </button>
      </div>
    </div>
  )
}
